import { useEffect, useState } from "react";
import OnlySubscribersAlert from "../Branding/OnlySubscribersAlert.js";
import IncreaseDecreaseBox from "components/Elements/IncreaseDecreaseBox/IncreaseDecreaseBox.js";
import RadioElement from "components/Elements/RadioElement/RadioElement.js";
import { useCustomController } from "components/Reusable/Form/useCustomController.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";

const CustomRadioButtonField = (props) => {
  const { fieldControls } = useCustomController(props);

  const { getUserData, setUserDataProp } = useUser();
  const { getTextByKey } = useContent();

  const [settings, setSettings] = useState({});
  const [autoRemovalDays, setAutoRemovalDays] = useState(7);

  useEffect(() => {
    const currentRemoveSettings =
      props.externalProps.settings.AutoRemoveSettings || {};
    setSettings({
      AutoRemoveDays: currentRemoveSettings.AutoRemoveDays,
      DefaultSaveMail: currentRemoveSettings.DefaultSaveMail,
    });
    setUserDataProp({
      key: "AutoRemoveDays",
      value: currentRemoveSettings.AutoRemoveDays,
    });
    setAutoRemovalDays(currentRemoveSettings.AutoRemoveDays);
  }, [props.externalProps.settings]);

  useEffect(() => {
    setSettings((prev) => ({
      ...prev,
      AutoRemoveDays: autoRemovalDays,
    }));
  }, [autoRemovalDays]);

  useEffect(() => {
    fieldControls.onChange(settings);
  }, [settings]);

  const AutoRemovalDaysContainer = () => {
    return (
      <div className="auto-removal-radio-button">
        {getTextByKey("auto-removal-text").replace("#Number#", autoRemovalDays)}
        <IncreaseDecreaseBox
          value={autoRemovalDays}
          setValue={setAutoRemovalDays}
          minValue={7}
          maxValue={365}
        />
      </div>
    );
  };

  const isUserSubscriber = getUserData().IsSubscribed;
  const isUserSubUser = getUserData().IsSubUser;

  const handleClickRadio = (value) => {
    setSettings((prev) => ({
      ...prev,
      DefaultSaveMail: value,
    }));
  };

  return (
    <>
      {!isUserSubscriber && (
        <div>
          <OnlySubscribersAlert
            title={"auto-removal-alert-title"}
            text={"auto-removal-alert-text"}
          />
        </div>
      )}
      {isUserSubUser && (
        <div className="setting-by-top-user">
          {getTextByKey("setting-is-set-by-top-user")}
        </div>
      )}
      <div className="auto-removal-container">
        {
          <div className={(!isUserSubscriber || isUserSubUser) && "disabled"}>
            <RadioElement
              state={settings.DefaultSaveMail}
              setState={handleClickRadio}
              fieldToCheck={false}
              textRadioObject={AutoRemovalDaysContainer()}
              tooltipRadio={"auto-removal-tooltip"}
              dislabeText={settings.DefaultSaveMail === true}
              tooltipOnHover
            />
            <RadioElement
              state={settings.DefaultSaveMail}
              setState={handleClickRadio}
              fieldToCheck={true}
              textRadioObject={getTextByKey("set-save-default-text")}
              tooltipRadio={"set-save-default-tooltip"}
              dislabeText={settings.DefaultSaveMail === false}
              tooltipOnHover
            />
          </div>
        }
      </div>
    </>
  );
};

export default CustomRadioButtonField;
